import { Globe, Mic, Youtube, BookOpen, PenLine, MessageCircle, LayoutGrid, Compass } from 'lucide-react';

export const DIMPLE_BUILD = {
  id: 'dimple',
  name: 'The Dimple Method\u2122',
  sub: 'Dimple Amore \u00b7 BBC-featured, best-selling author, top 5% global podcast',
  intro: 'Our most comprehensive Pro Plan build to date. One owned home for her whole business, with every channel produced, published and cross-linked by Audio & Co.',
  site: 'https://dimplemethod.com',
  host: 'dimplemethod.com',
  folder: 'dimple',
  shots: [
    { key: 'home', label: 'Website', icon: Globe, path: '/', alt: 'The Dimple Method homepage, a business website built for SEO by Audio & Co. for author and advisor Dimple Amore', title: 'The Dimple Method website | Built by Audio & Co.' },
    { key: 'podcast', label: 'Podcast', icon: Mic, path: '/podcast', alt: 'Beyond the Words podcast page on dimplemethod.com, a top 5% global show run by Audio & Co. podcast management', title: 'Beyond the Words podcast | Audio & Co.' },
    { key: 'watch', label: 'YouTube', icon: Youtube, path: '/watch', alt: 'Dimple Amore YouTube video library on dimplemethod.com, a channel managed end to end by Audio & Co.', title: 'Dimple Amore on YouTube | Audio & Co.' },
    { key: 'book', label: 'Book', icon: BookOpen, path: '/book', alt: 'The Roadmap to Purpose book page on dimplemethod.com, a bestseller formatted and audiobook recorded by Audio & Co.', title: 'The Roadmap to Purpose | Audio & Co.' },
    { key: 'blog', label: 'Articles', icon: PenLine, path: '/blog', alt: 'Long-form articles with audio narration on dimplemethod.com, written to rank on a website built for SEO by Audio & Co.', title: 'Dimple Method articles | Audio & Co.' },
    { key: 'pocket', label: 'AI companion', icon: MessageCircle, path: '/pocket', alt: 'Dimple in Your Pocket AI companion app page on dimplemethod.com, built by Audio & Co.', title: 'Dimple in Your Pocket | Audio & Co.' },
  ],
  deliverables: [
    'Business website on her own domain',
    'Podcast production (top 5% globally)',
    'YouTube channel managed end-to-end',
    '70+ long-form articles, each with audio',
    'Fully trained AI chatbot',
    'Two flagship programmes launched',
    'Book formatted + audiobook recorded',
    'Companion journal designed in-house',
  ],
  mobileAlt: 'The Dimple Method website on a mobile phone, a responsive business website built for SEO by Audio & Co.',
};

export const THRIVE_BUILD = {
  id: 'thrive',
  name: 'Thrive \u00b7 Treat Your Business',
  sub: 'Katie Bell \u00b7 Business coach to 500+ UK clinic owners, Amazon best-selling author',
  intro: 'A full business container in one place. Website, chatbot, podcast, YouTube, articles, strategy and audiobook, all built, produced and shipped by Audio & Co. on her own domain.',
  site: 'https://thrive-businesscoaching.com',
  host: 'thrive-businesscoaching.com',
  folder: 'thrive',
  shots: [
    { key: 'home', label: 'Website', icon: Globe, path: '/', alt: 'Thrive business coaching homepage for clinic owners, a website built for SEO by Audio & Co. for Katie Bell', title: 'Thrive website | Built by Audio & Co.' },
    { key: 'listen', label: 'Podcast', icon: Mic, path: '/listen', alt: 'Treat Your Business podcast library with 211 episodes on thrive-businesscoaching.com, run by Audio & Co.', title: 'Treat Your Business podcast | Audio & Co.' },
    { key: 'watch', label: 'YouTube', icon: Youtube, path: '/watch', alt: 'Katie Bell YouTube library with 87 videos and 2,413 Shorts, managed by Audio & Co. podcast management', title: 'Katie Bell on YouTube | Audio & Co.' },
    { key: 'learn', label: 'Articles', icon: PenLine, path: '/learn', alt: 'Thrive Learn hub with 237 SEO articles for UK clinic owners, written and published by Audio & Co.', title: 'Thrive articles | Audio & Co.' },
    { key: 'topics', label: 'Topic hubs', icon: LayoutGrid, path: '/topics', alt: 'Thrive topic hubs grouping podcast episodes, videos and articles into 14 categories, built by Audio & Co.', title: 'Thrive topic hubs | Audio & Co.' },
    { key: 'start', label: 'Start here', icon: Compass, path: '/start-here', alt: 'Thrive start here page guiding new physiotherapists and clinic owners, a website journey built by Audio & Co.', title: 'Thrive start here | Audio & Co.' },
  ],
  deliverables: [
    'Business website on her own domain',
    'Fully trained AI chatbot',
    'Podcast production, 211 episodes',
    'Podcast strategy and planning',
    'YouTube: 87 videos + 2,413 Shorts',
    '237 SEO articles and blogs',
    '14 topic hubs linking every asset',
    'Her audiobook recorded and produced',
  ],
  mobileAlt: 'Thrive business coaching website on a mobile phone, a responsive website built for SEO by Audio & Co.',
};
